import SettingFrame from "../../../../components/@settings/SettingFrame";
import ListUserRoles from "../../../../components/@user_roles/roles/ListUserRoles"

import { routeTypes } from "../../../../hooks/useSystemRoutes";

export default function UserRolesPage() {

    let routeType = routeTypes.admin

    return (
        <SettingFrame
            routeType={routeType}
        >
            <ListUserRoles
                routeType={routeType}
            />
        </SettingFrame>
    )
}